export default __webpack_public_path__ + "static/media/tp.1bc8d3c8.jpg";